/* Standard SUNTRONIX quote-term pickers: Delivery schedule + Price validity dropdowns with a "Custom…" escape hatch. */
import { useState } from "react";
import { Input } from "@/components/ui/input";

export const DELIVERY_OPTIONS = [
  "2 Working Days from the date of Official P.O.",
  "2 - 4 Working Days from the date of Official P.O.",
  "5 - 7 Working Days from the date of Official P.O.",
  "10 - 15 Working Days from the date of Official P.O.",
  "20 - 30 Working Days from the date of Official P.O.",
  "5 - 8 Weeks from the date of Official P.O.",
  "8 - 12 Weeks from the date of Official P.O.",
];
export const VALIDITY_OPTIONS = [
  "2 Days from the date of this Quote",
  "3 Days from the date of this Quote",
  "7 Days from the date of this Quote",
  "15 Days from the date of this Quote",
  "30 Days from the date of this Quote",
];
const CUSTOM = "__custom__";

const match = (options, value) => { const v = (value || "").trim().toLowerCase(); if (!v) return null; return options.find((o) => o.toLowerCase() === v) || options.find((o) => o.toLowerCase().startsWith(v)) || null; };

export function TermSelect({ value, onChange, options, placeholder, className = "", testId }) {
  const matched = match(options, value);
  const [custom, setCustom] = useState(!!value && !matched);
  const showCustom = custom || (!!value && !matched);
  return (
    <div className={`space-y-1 ${className}`}>
      <select value={showCustom ? CUSTOM : matched || ""} data-testid={testId}
        onChange={(e) => { if (e.target.value === CUSTOM) { setCustom(true); if (matched) onChange(""); } else { setCustom(false); onChange(e.target.value); } }}
        className="h-9 w-full rounded-md border border-slate-200 bg-white px-2 text-[13px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-200">
        <option value="">— select —</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
        <option value={CUSTOM}>Custom…</option>
      </select>
      {showCustom && <Input className="h-9" autoFocus placeholder={placeholder} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId ? `${testId}-custom` : undefined} />}
    </div>
  );
}

export const DeliveryScheduleSelect = (p) => <TermSelect options={DELIVERY_OPTIONS} placeholder="e.g. 7–10 working days from receipt of confirmed PO" {...p} />;
export const PriceValiditySelect = (p) => <TermSelect options={VALIDITY_OPTIONS} placeholder="e.g. Valid until 30-Jun-2026" {...p} />;
